<template>
  <div id="billboard-payments">
    <spinner v-if="loading" message="Loading..." line-fg-color="#E95253"></spinner>
    <vue-good-table v-else :columns="columns" :rows="payments" :search-options="{enabled: true, placeholder:'Search'}"
                    :paginationOptions="{ enabled: true }"
                    :lineNumbers="payments.length ? true : false" styleClass="table table-striped table-bordered">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'amount'">
          KES {{ formatNumber(props.row.amount) }}
        </span>
        <span v-else-if="props.column.field == 'download'">
          <a href="javascript: void(0)" @click="downloadReceipt(props.row.receiptNo)">
            <i class="fa fa-file-pdf-o"></i>
          </a>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <div slot="emptystate">
        No records to display
      </div>
      <div slot="table-actions">
        <button class="btn btn-primary" @click="loadPayHistory(billboardId)">
          <i class="fa fa-refresh"></i>
        </button>
      </div>
    </vue-good-table>
  </div>
</template>
<script>
  import api from "../../../../api";
  import helpers from "../../../../helpers";
  import config from "../../../../config";
  import spinner from "vue-simple-spinner";

  export default {
    name: "billboard-payment-history",
    props: ["billboardId"],
    data: function () {
      return {
        payments: [],
        loading: false,
        loadingMsg: "",
        token: this.$store.state.token,
        columns: [
          {
            label: "Receipt No.",
            field: "receiptNo"
          },
          {
            label: "Payment Method",
            field: "paymentMode"
          },
          {
            label: "Date",
            field: "paymentDate",
            type: "date",
            dateInputFormat: "YYYY-MM-DD HH:mm:ss",
            dateOutputFormat: config.dateFormat
          },
          {
            label: "Amount",
            field: "amount"
          },
          {
            label: "Download",
            field: "download"
          }
        ]
      };
    },
    components: {
      spinner
    },
    methods: {
      formatNumber(number) {
        return helpers.formatNumber(number);
      },
      loadPayHistory(billboardId) {
        this.loading = true;
        this.loadingMsg = "Loading...";

        const txType = "get-billboards-payment-history";
        let data = {
          token: this.token,
          billboardId: billboardId
        };
        api
          .request(txType, data)
          .then(response => {
            if (response.data.status === "00") {
              this.loading = false;
              this.payments = response.data.paymentHistory;
            } else {
              this.loading = false;
              this.loadingMsg = response.data.message;
              this.payments = [];
            }
          })
          .catch(error => {
            helper.errorAlert(
              "A connection to the serve could not be established. Please try later."
            );
            console.log(error);
          });
      },
      downloadReceipt(receiptNo) {
        const txType = "download-billboards-receipt";
        let data = {
          token: this.token,
          receiptNo: receiptNo,
          billboardId: this.billboardId
        };
        api
          .request(txType, data)
          .then(response => {
            if (response.data.status === "00") {
              let form = document.createElement("form");
              form.setAttribute("action", response.data.url);
              form.setAttribute("method", "POST");
              document.body.appendChild(form);
              form.submit();
            } else {
              console.log(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    created: function () {
      this.loadPayHistory(this.billboardId);
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/services/advertising/datatables/PaymentHistory.vue